
export default {
  props: ["menu", "path"],
};
